<template>
    <div>
        <template v-if="corp_status == true">
            <template v-if="is_submit == false">
                <div>
                    <div class="global-main bank-account-linking">
                        <div class="bank-account-linking-inner">
                            <div class="align-center">
                                    <img class="mb-3" src="/images/meezan-logo.jpg" width="250" alt="" /> <br>
                            </div>
                            <h2 class="mb-4"> Account Linking </h2>
                            <form @submit.prevent="accountLinking()">
                                <div class="form-group">
                                    <label class="label block-label"> Account Number </label>
                                    <input type="text" class="form-control" readonly name="AccountNo" @keypress="isNumber($event)" maxlength="14" v-model="form.AccountNo" :class="{ 'is-invalid': form.errors.has('AccountNo') }" autocomplete="off"/>
                                    <has-error :form="form" field="AccountNo"></has-error>
                                </div>
                                <div class="form-group">
                                    <label class="label block-label"> NTN Number </label>
                                    <input type="text" class="form-control" readonly placeholder="Enter NTN Number" name="NTN" maxlength="13" v-model="form.NTN" :class="{ 'is-invalid': form.errors.has('NTN') }" autocomplete="off"/>
                                    <has-error :form="form" field="NTN"></has-error>
                                </div>
                                <div class="form-group mb-0 text-right">
                                    <button :disabled="form.busy" class="btn btn-primary proceed active"> Proceed </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="is_submit == true">
                <accountLinkingSuccess></accountLinkingSuccess>
            </template>
        </template>
        <template v-else-if="corp_status === null">
            <preLoader></preLoader>
        </template>
        <template v-else>
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
import accountLinkingSuccess from './accountLinkingSuccessComponent.vue';
    export default {
        components: {
            accountLinkingSuccess,
        },
        data() {
            return {
                is_submit : false,
                form: new Form({
                    AccountNo: '',
                    NTN : '',
                }),
                corp_status: null,
                account_management: null
            };
        },
        methods: {
            accountLinking(){
                this.is_submit = true;
                this.$Progress.start();
                this.form.post("/api/accountLinking")
                .then(res => {
                    if(res.status == 200){
                        if(res.data.code == 200){
                            this.$Progress.finish();
                            window.location.href = "/createMpin";
                        }else{
                            this.is_submit = false;
                            this.$Progress.fail();
                            this.showAlertBox('error', res.data.msg);
                        }
                    }else{
                        this.is_submit = false;
                        this.$Progress.fail();
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Some error in your form data');
                });
            },

            getCompanyAccountNo(){
                this.$Progress.start();
                axios.get('/api/getCompanyAccountNo')
                .then(res => {
                    if(res.status == 200){
                        this.form.AccountNo = this.makeMask(res.data.company.walletID);                       
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            },
            getCompanyNTN(){
                this.$Progress.start();
                axios.get('/api/getCompanyNTN')
                .then(res => {
                    if(res.status == 200){
                        this.form.NTN = res.data.company.ntn;
                        if(res.data.company.corp_account_status == "INITIAL"){
                            this.corp_status = true;
                        }else{
                           this.corp_status = false;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            }
        },
        mounted() {
            this.getCompanyNTN();
            this.getCompanyAccountNo();
        },
    }
</script>
